module.exports = __webpack_public_path__ + "img/idea3-white.625b7b7f.png";